module.exports = __webpack_public_path__ + "static/logo-a89369b3704031f90148d824f41ece71.png";